import Header from "@/types/app/header";

export default class ManagerHeader {
  public static header: Header[] = [    
    {
      text: "Name",
      align: "start",
      sortable: true,
      value: "name",
      class: "item-table-header item-table-header-name",
      width: ""
    },    
    {
      text: "Email",
      align: "start",
      sortable: true,
      value: "email",
      class: "item-table-header item-table-header-name",
      width: ""
    },    
    {
      text: "",
      align: "right",
      value: "actions",
      sortable: false,
      class: null,
      width: ""
    }
  ];
}
